import {Component, computed, EventEmitter, inject, input, Output} from '@angular/core';
import {Rating} from '@core/interfaces/generated/graphql';
import {
  ProductCompactRatingPointsComponent
} from '@layout/components/product/product-compact-rating/product-compact-rating-points/product-compact-rating-points.component';
import {ReadMoreComponent} from '@layout/components/general/read-more/read-more.component';
import {GridService} from '@core/services/grid.service';
import {TextFormatterService} from '@core/services/text-formatter.service';

@Component({
  selector: 'app-product-rating',
  templateUrl: './product-rating.component.html',
  imports: [
    ProductCompactRatingPointsComponent,
    ReadMoreComponent
  ],
  styleUrl: './product-rating.component.scss'
})
export class ProductRatingComponent {

  gridService = inject(GridService)
  private textFormatterService = inject(TextFormatterService);

  rating = input.required<Rating>();

  @Output() toggleReadMore = new EventEmitter<boolean>();

  formattedReview = computed(() => {
    return this.textFormatterService.formatNewlinesToHtml(this.rating().review);
  });

}
